module.exports = __webpack_public_path__ + "img/3.83531691.jpg";